/* eslint-disable react/require-default-props */

import React from 'react';

class ColorLegend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [
        {
          text: 'Forecast',
          color: '#e3bff5',
        },
        {
          text: 'Actual',
          color: '#3e0b6c',
        },
      ],
    };
  }

  render() {
    return (
      <section className={`color-legend${this.props.additionalClass ? this.props.additionalClass : ''}`}>
        {this.state.items.map((item) => (
          <div key={item.color} className="color-item">
            <span style={{ backgroundColor: item.color }} />
            {item.text}
          </div>
        ))}
      </section>
    );
  }
}

export default ColorLegend;
